// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"SS8SL2p","box-content":"j7ElmVm","boxContent":"j7ElmVm","box":"QMfjvb8"};